<template>
    <div class="upload-container">
        <input class="upload-image"  upload-icon="plus" :maxlength="maxNumber"  type="file" name="pic" ref="file" accept="image/*" @change="upload"/>
        <slot></slot>
    </div>
</template>

<script>
export default {
  props: {
    types:{
      type:String
    },
    maxNumber: {
      type: Number,
      default: 1,
    },
    encryption:{
      type:Boolean,
      default:false
    },
    list:{
      type:Array,
      default:() => []
    }
  },
  methods: {
    upload(e) {

      console.log(this.maxNumber, "每次上传最多图片数量");
      this.uploadNum = 0;
      if(this.list.length == this.maxNumber) return  this.$message.error(`超出上传最大范围`);
      this.iosImgList = [];
      console.log('size1111',  e.target.files[0].size);

      if (this.types == 'headImg' && e.target.files[0].size > 1024000) {
          this.$message.error("上传图片不能超过1M!");
        return;
      } else if (this.types != 'headImg' && e.target.files[0].size > 5120000) {
          this.$message.error("上传图片不能超过5M!");
         return;
      }

      if (e.target.files.length > 0) {
        // Toast({
        //   duration: 0, // 持续展示 toast
        //   forbidClick: true,
        //   message: "上传中...",
        // });
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        let uploadNum = 0;
        for (let i in files) {
          if (files[i].type) {
            uploadNum += 1;
          }
        }
        this.uploadNum = uploadNum;
        console.log("上传图片数量!!!!", this.uploadNum);
        // this.picValue = files[0]
        // this.uploadName = files[0].name

        // 上传图片
        let u = navigator.userAgent;
        // app = navigator.appVersion

        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) {
          console.log("安卓");
          let blobs = [];
          for (let i in files) {
            if (files[i].type) {
              blobs.push(files[i]);
            }
          }
          this.axiosFun(blobs);
        }
        if (isIOS) {
          console.log("IOS");
          for (let i in files) {
            if (files[i].type) {
              this.imgPreview(files[i], i);
            }
          }
        }
        
        let blobs = [];
        for (let i in files) {
            if (files[i].type) {
                blobs.push(files[i]);
            }
        }
        this.axiosFun(blobs);
        // this.axiosFun(blobs)
        // 上传视频
        // this.axiosFun(this.picValue);
      }
    },
    compress(img, Orientation) {
      let _this = this;
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      // 瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      // let initSize = img.src.length
      let width = img.width;
      let height = img.height;
      // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // 如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); // 计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      console.log(Orientation, "ios拍照上传");
      // 修复ios上传图片的时候 被旋转的问题
      if (Orientation !== "" && Orientation !== 1) {
        let version = navigator.userAgent
          .toLowerCase()
          .match(/cpu iphone os (.*?) like mac os/)[1]
          .replace(/_/g, ".")
          .split(".");
        switch (Orientation) {
          case 6: // 需要顺时针（向左）90度旋转
            if (version[0] > 13 || (version[0] == 13 && version[1] >= 4)) {
              console.log("13.4及以上版本ios，图片不需要旋转处理");
            } else {
              console.log("13.4以下版本ios，图片旋转处理");
              _this.rotateImg(img, "left", canvas);
            }
            break;
          case 8: // 需要逆时针（向右）90度旋转
            _this.rotateImg(img, "right", canvas);
            break;
          case 3: // 需要180度旋转
            _this.rotateImg(img, "right2", canvas);
            break;
        }
      }
      // 进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg(img, direction, canvas) {
      console.log(direction, "ios拍照旋转问题");
      // 最小与最大旋转方向，图片旋转4次后回到原方向
      const minStep = 0;
      const maxStep = 3;
      if (img === null) return;
      // img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step === null) {
        step = minStep;
      }
      if (direction === "right") {
        step++;
        // 旋转到原位置，即超过最大值
        step > maxStep && (step = minStep);
      } else if (direction === "right2") {
        step = 2;
      } else {
        step--;
        step < minStep && (step = maxStep);
      }
      // 旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    postImg() {
      // 这里写接口
      console.log(this.iosImgList.length, "上传数量");
      if (this.uploadNum !== this.iosImgList.length) {
        return;
      }
      if (
        this.iosImgList.some((item) => {
          if (item == undefined) {
            return true;
          }
        })
      ) {
        return;
      }
      let blobs = [];
      this.iosImgList.map((item) => {
        const block = item.split(";");
        const contentType = block[0].split(":")[1]; // In this case "image/jpeg"
        const realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
        blobs.push(this.b64toBlob(realData, contentType));
      });
      if (blobs.length == 0 || blobs.length < this.uploadNum) {
        return;
      }
      console.log(blobs.length, "上传数量，执行几次");
      this.axiosFun(blobs);
    },
    async uploadDefined(files, data) {
      // let _this = this
      console.log('size',files[0].size)
      console.log('files',files[0])

      
      return Promise.all(
        files.map(
          (file) =>
            new Promise((resolve) => {
              let gObjectName =
                data.dir + this.types+'/'+
                new Date().getTime() +
                Math.floor(Math.random() * 150) +
                ".png";
              let request = new FormData();
              request.append("OSSAccessKeyId", data.accessid); // Bucket 拥有者的Access Key Id。
              request.append("policy", data.policy); // policy规定了请求的表单域的合法性
              request.append("Signature", data.signature); // 根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
              request.append("key", gObjectName); // 文件名字，可设置路径
              request.append("success_action_status", "200"); // 让服务端返回200,不然，默认会返回204
              request.append("x-oss-object-acl", "default");
              request.append("file", file);

              let xhr = new XMLHttpRequest();
              xhr.open("POST", data.host);
              xhr.send(request);
              xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                  console.log("fileKey => " + data.host + "/" + gObjectName);
                  // console.log(_this.imgPaths);
                  // _this.$vux.loading.hide()
                  console.log(`${data.host}/${gObjectName}`, "成功图片名称");
                  resolve(`${data.host}/${gObjectName}`);
                } else if (xhr.status === 400) {
                //   Toast.clear();
                   this.$message.error("图片太大,请换取小的图片");
                }
              };
            })
        )
      );
    },
    async imgUpload() {
      // const { data } = await uploadImg({url: host, })
    },
    async axiosFun(blob) {
      try {
        let that = this;
        let url='/aliyun/oss-token'
        if(this.encryption){
          url='/aliyun/oss-token'
        }
        const {data} = await this.$apiFetch.get(url);
        console.log(data.code != 0,'cccc')
        if (data.code) {
        //   Toast.clear();
           this.$message.error(data.message);
          return;
        }

        const resultImgs = await that.uploadDefined(blob, data);
        console.log(resultImgs,'resultImgs')
        // Toast.clear();
        this.$message.success("上传成功!");
        this.$emit("uploadImgs", resultImgs);
      } catch (error) {
        // Toast.clear();
         this.$message.error("上传失败!");
        console.log(error);
      }
    },
    randomString(len) {
      len = len || 32;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      let maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    getSuffix(filename) {
      console.log(filename, "文件名");
      let pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos !== -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
};
</script>

<style lang="less" scoped>
.upload-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 84px;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  z-index: 999;
}
.upload-container {
  position: relative;
}
</style>
